import { useSelector } from 'react-redux';

function useIsMobile() {
  const maxWidth = useSelector((state) => state.layout.maxWidth);
  const maxHeight = useSelector((state) => state.layout.maxHeight);

  const isMobile = maxWidth <= 780 || maxHeight <= 520;

  return { isMobile };
}

export default useIsMobile;
